export const POSITIONS = [
    {
        label: 'Officers',
        positions: [
            'Jail Chief Superintendent (JCSupt.)',
            'Jail Senior Superintendent (JSSupt.)',
            'Jail Superintendent (JSupt.)',
            'Jail Chief Inspector (JCInsp.)',
            'Jail Senior Inspector (JSInsp.)',
            'Jail Inspector (JInsp.)',
            ]
    },
    {
        label: 'Non-Commissioned Personnel and Agents',
        positions: [
            'Senior Jail Officer IV (SJO4)',
            'Senior Jail Officer III (SJO3)',
            'Senior Jail Officer II (SJO2)',
            'Senior Jail Officer I (SJO1)',
            'Jail Officer III (JO3)',
            'Jail Officer II (JO2)',
            'Jail Officer I (JO1)',
            ]
    },
    {
        label: 'Non-Uniformed Personnel',
        positions: [
            'Non-Uniformed Personnel (NUP)',
            ]
    }
]